import React from 'react'
import { useState } from 'react';
import { FaRegLifeRing } from "react-icons/fa6";
import { FaRegRegistered } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { BiSolidUserBadge } from "react-icons/bi";

import { FaRegMessage } from "react-icons/fa6";
import { TbBrandGoogleFilled } from "react-icons/tb";
import { CiVoicemail } from "react-icons/ci";
import { FaChartBar } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";






// components
import DynamicComponentforDatewise from './DynamicComponentforDatewise';


function DateWiseStatistics() {

    const [activeTab, setActiveTab] = useState("SMSStatistics");

    const tabList = [
        {
            id: "SMSStatistics", label: "SMS Statistics", icon: <FaRegMessage />
            , component: <DynamicComponentforDatewise Title={'SMS Date Wise Statistics'}  />
        },
        {
            id: "RCSStatistics", label: "RCS Statistics", icon: <TbBrandGoogleFilled />
            , component: <DynamicComponentforDatewise Title={'RCS Date Wise Statistics'}  />
        },
        {
            id: "WhatsAppStatistics", label: "WhatsApp Traffict", icon: <FaWhatsapp />
            , component: <DynamicComponentforDatewise Title={'WhatsApp Date Wise Statistics'} />
        },
        {
            id: "VoiceStatistics", label: "Voice Traffict", icon: <CiVoicemail />
            , component: <DynamicComponentforDatewise Title={'Voice Date Wise Statistics'}  />
        },
        {
            id: "TTSStatistics", label: "TTS Traffict", icon: <FaChartBar />
            , component: <DynamicComponentforDatewise Title={'TTS Date Wise Statistics'}  />
        },
        {
            id: "CTCStatistics", label: "CTC Traffic", icon: <FaChartLine />
            , component: <DynamicComponentforDatewise Title={'CTC Date Wise Statistics'}  />
        },
    ];

    return (
        <>
            <div className='dark:bg-[#121519] h-[100vh]'>
                <div className=' w-[100%] flex md:pt-[70px] gap-1 px-2 pt-[120px] dark:bg-[#121519]  '>
                    {tabList.map((item, index) =>
                        <button
                            onClick={() => setActiveTab(item.id)}
                            className={` w-[16%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                    )
                    }
                </div>
                <div className="pt-4 px-2 dark:bg-[#121519]">
                    {tabList.find((t) => t.id === activeTab)?.component}
                </div>
            </div>
        </>
    )
}

export default DateWiseStatistics
